import { GET_ACCESS_RESTRICTION } from "./accessRestrictionActionType";

export const getAccessRestriction = (dossierStatus , user) => ({
    type: GET_ACCESS_RESTRICTION,
    payload: { dossierStatus , user }
});
